exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tblClass[data-v-4bc34a5a]{border-collapse:collapse}.tblClass tr td[data-v-4bc34a5a],.tblClass tr th[data-v-4bc34a5a]{border:1px solid #ccc;padding:8px 0}.textCenter[data-v-4bc34a5a],.textCenter tr td[data-v-4bc34a5a],.textCenter tr th[data-v-4bc34a5a]{text-align:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4bc34a5a","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/administration/vehicle_info/vehicle_expiry_details.vue
// module id = 1308
// module chunks = 3